/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Forced_Aria_LabelInputs */

const en_event_forced_aria_label = /** @type {(inputs: Event_Forced_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle forced subtitle`)
};

const fr_event_forced_aria_label = /** @type {(inputs: Event_Forced_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basculer le sous-titre force`)
};

const de_event_forced_aria_label = /** @type {(inputs: Event_Forced_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitel erzwingen/umschalten`)
};

const it_event_forced_aria_label = /** @type {(inputs: Event_Forced_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva/disattiva i sottotitoli forzati`)
};

const ru_event_forced_aria_label = /** @type {(inputs: Event_Forced_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить/выключить принудительные субтитры`)
};

const es_event_forced_aria_label = /** @type {(inputs: Event_Forced_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activar o desactivar subtítulos forzados`)
};

const zh_cn2_event_forced_aria_label = /** @type {(inputs: Event_Forced_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换强制字幕`)
};

const ja_event_forced_aria_label = /** @type {(inputs: Event_Forced_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`強制字幕の切り替え`)
};

const hi_event_forced_aria_label = /** @type {(inputs: Event_Forced_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनिवार्य उपशीर्षक को चालू/बंद करें`)
};

const pt_pt2_event_forced_aria_label = /** @type {(inputs: Event_Forced_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativar/desativar legendas forçadas`)
};

/**
* | output |
* | --- |
* | "Toggle forced subtitle" |
*
* @param {Event_Forced_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_forced_aria_label = /** @type {((inputs?: Event_Forced_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Forced_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_forced_aria_label(inputs)
	if (locale === "de") return de_event_forced_aria_label(inputs)
	if (locale === "it") return it_event_forced_aria_label(inputs)
	if (locale === "ru") return ru_event_forced_aria_label(inputs)
	if (locale === "es") return es_event_forced_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_forced_aria_label(inputs)
	if (locale === "ja") return ja_event_forced_aria_label(inputs)
	if (locale === "hi") return hi_event_forced_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_forced_aria_label(inputs)
	return en_event_forced_aria_label(inputs)
});